const brandSubtitle = '#header-brand-subtitle';
const subtitleContents = jQuery(brandSubtitle).html().replace('•', '<span id="bullet">&bull;</span>');
jQuery(brandSubtitle).html(subtitleContents);

const slideInLeftClass = 'slide-in-left';
const slideOutLeftClass = 'slide-out-left';
const navigationSelector = '#header-navigation';
const navigationBarsSelector = '#header-navigation-bars';
const siteOverlaySelector = '#site-overlay';
const menuCancelSelector = "#header-navigation-cancel";

const bodySelector = "body";
const overflowCssAttribute = "overflow";

jQuery(navigationBarsSelector).click(function() {
    // Disable scrolling for all content behind the slide-out menu.
    jQuery(bodySelector).css(overflowCssAttribute, "hidden");
    jQuery(siteOverlaySelector).fadeIn(300);

    // Slide the menu out.
    jQuery(navigationSelector).removeClass(slideInLeftClass).addClass(slideOutLeftClass);
});

jQuery(`${menuCancelSelector}, ${siteOverlaySelector}`).click(function() {
    // Enable scrolling for main content.
    jQuery(bodySelector).css(overflowCssAttribute, "");
    jQuery(siteOverlaySelector).fadeOut(300);

    // Slide the menu back in.
    jQuery(navigationSelector).removeClass(slideOutLeftClass).addClass(slideInLeftClass);
});